<template>
  <div class="container mx-auto">
    <el-dialog
      :visible.sync="showEditDialog"
      width="1100px"
      :close-on-click-modal="false"
    >
      <span slot="title">
        <el-row :gutter="15">
          <el-col :span="18">
            <span class="text-sm">{{
              `NOMBRE: ${data.general.name1} ${
                data.general.lastname1
              } | NUEVO CÓDIGO: ${data.general.code} | CODIGO ANTERIOR: ${
                data.general.priorCode !== null
                  ? data.general.priorCode
                  : "----"
              }`
            }}</span>
          </el-col>
          <el-col :span="5" class="flex justify-end">
            <el-button-group>
              <el-button
                size="mini"
                type="info"
                icon="el-icon-arrow-left"
                @click="prevEdit(data.general.id, rawEmployees, 'edit')"
              />
              <el-button
                size="mini"
                type="info"
                icon="el-icon-arrow-right"
                @click="nextEdit(data.general.id, rawEmployees, 'edit')"
              />
            </el-button-group>
          </el-col>
        </el-row>
      </span>
      <el-tabs v-model="tabRef" v-loading="loadingEdit">
        <el-tab-pane label="Fotografía" name="photo">
          <div class="flex flex-col items-center justify-center">
            <label
              for="avatar"
              class="
                mb-5
                border
                rounded
                bg-orange-600
                hover:bg-orange-500
                text-xs text-orange-100
                cursor-pointer
                px-4
                py-2
              "
              >Seleccionar imagen</label
            >
            <input
              id="avatar"
              ref="avatar"
              type="file"
              accept="image/*"
              @change="preview_image($event)"
              class="hidden"
            />
            <img
              id="output_image"
              ref="output_image"
              class="w-64 rounded-lg min-h-64 border-dashed border-2"
              :src="previewImage"
            />
          </div>

          <div class="flex flex-row justify-end mt-5">
            <el-button size="small" @click="showEditDialog = false"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" @click="uploadPicture()"
              >Guardar</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="General" name="general">
          <new-tab-general
            :values="data.general"
            next-name="Guardar"
            :require-confirm="true"
            :key="data.general.id"
            :show-cancel="true"
            @save="afterUpdateEmployee"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Contacto" name="contact">
          <dialog-contact
            :values="data.general"
            :countries="countries"
            :key="data.general.id"
            @save="afterUpdateEmployee"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Documentos" name="documents">
          <new-tab-documents
            :key="data.general.id"
            :values="data.documents"
            next-name="Guardar"
            :require-confirm="true"
            :country="data.general.country"
            :contract-id="data.general.id"
            :show-cancel="true"
            @save="afterUpdateEmployee"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Estudios" name="studies">
          <dialog-studies
            :key="data.general.id"
            :employeeID="data.general.id"
            :values="data.studies"
            :levels="levels"
            :institutions="institutions"
            :careers="careers"
            @save="afterUpdateEmployee"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Familiares" name="family">
          <dialog-families
            :key="data.general.id"
            :employeeID="data.general.id"
            :values="data.employeeFamilies"
            :relationships="relationships"
            @save="afterUpdateEmployee"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Banco" name="bank">
          <el-form
            :model="bankAccountForm"
            status-icon
            :rules="bankAccountFormRules"
            ref="bankAccount"
            @submit.native.prevent="
              submitBankAccount('bankAccount', bankAccountForm, data.general.id)
            "
          >
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="11" class="flex flex-col justify-center">
                <el-form-item label="Banco" prop="bank">
                  <el-select
                    filterable
                    clearable
                    v-model="bankAccountForm.bank"
                    placeholder="Seleccionar banco"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="b in rawBanks"
                      :key="b.id"
                      :label="b.name"
                      :value="b.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="13" class="flex flex-col justify-center">
                <el-form-item label="N° de cuenta" prop="bankAccount">
                  <el-input
                    clearable
                    v-model="bankAccountForm.bankAccount"
                    placeholder="Ingresar el N° de cuenta"
                    class="w-full"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item class="flex justify-end mb-0">
              <el-button size="small" @click="showEditDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit"
                >Guardar</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Otros" name="other">
          <dialog-other
            :values="data.general"
            :key="data.general.id"
            @save="afterUpdateEmployee"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog
      :visible.sync="showAssignAP"
      width="1300px"
      :close-on-click-modal="false"
    >
      <span slot="title">
        <el-row :gutter="15">
          <el-col :span="18">
            <span class="text-sm">{{
              `NOMBRE: ${data.general.name1} ${
                data.general.lastname1
              } | NUEVO CÓDIGO: ${data.general.code} | CODIGO ANTERIOR: ${
                data.general.priorCode !== null
                  ? data.general.priorCode
                  : "----"
              }`
            }}</span>
          </el-col>
        </el-row>
      </span>
      <el-form
        :model="assignAP"
        status-icon
        ref="newAP"
        label-position="top"
        @submit.native.prevent="
          submitNewAP('newAP', assignAP, selectedAP, data)
        "
      >
        <el-row :gutter="15" class="border-t pt-4 text-xs">
          <el-col :span="9">
            <el-form-item
              label="Seleccione accion de personal"
              prop="personalAction"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="assignAP.personalAction"
                placeholder="Select"
                size="small"
                class="w-full"
                clearable
                default-first-option
                @change="getSelectedAP(assignAP.personalAction)"
                filterable
              >
                <el-option
                  v-for="c in personalActions"
                  :key="c.id"
                  :label="`${c.type.name}: ${c.name}`"
                  :value="c.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="¿Afecta salario?">
              <el-input
                size="small"
                disabled
                :value="
                  selectedAP ? (selectedAP.affectsPaysheet ? 'SI' : 'NO') : ''
                "
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="Forma">
              <el-input
                size="small"
                disabled
                :value="
                  selectedAP
                    ? selectedAP.affectsMethod == 1
                      ? 'Dias'
                      : 'Cantidad'
                    : ''
                "
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="Tipo">
              <el-input
                size="small"
                disabled
                :value="
                  selectedAP
                    ? selectedAP.isFixedValue
                      ? 'Fijo'
                      : 'Variable'
                    : ''
                "
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="Valor fijo">
              <el-input
                size="small"
                disabled
                :value="
                  selectedAP
                    ? selectedAP.fixedValue
                      ? selectedAP.fixedValue
                      : 'N/A'
                    : '' | formatMoney
                "
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="¿Recurrente?">
              <el-input
                size="small"
                disabled
                :value="
                  selectedAP ? (selectedAP.isRecurrent ? 'SI' : 'NO') : ''
                "
                placeholder=""
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="15"
          class="border-b mb-4 text-xs"
          v-if="selectedAP && selectedAP.category === 'single'"
        >
          <el-col :span="3">
            <el-form-item
              label="Aplicar en mes"
              prop="selectedMonth"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-date-picker
                class="w-full"
                style="width: 100%"
                size="small"
                v-model="assignAP.selectedMonth"
                type="month"
                placeholder="Seleccionar"
                format="MM/yyyy"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5" class="flex flex-col space-y-2">
            <el-form-item
              label="Aplicar en quincena"
              prop="quincena"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-radio-group v-model="assignAP.quincena">
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-radio size="small" class="w-full" label="Q1" border>
                      Quincena 1
                    </el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio size="small" class="w-full" label="Q2" border>
                      Quincena 2
                    </el-radio>
                  </el-col>
                </el-row>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="!selectedAP.isFixedValue">
            <el-form-item
              :label="
                `Descuento: ${
                  selectedAP
                    ? selectedAP.affectsMethod == 1
                      ? '(DIAS)'
                      : '(DINERO)'
                    : ''
                }`
              "
              prop="noFixedValue"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-input-number
                :min="0"
                :step="0.01"
                placeholder="Cantidad"
                v-model="assignAP.noFixedValue"
                size="small"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col
            :span="3"
            v-if="
              (!selectedAP.endDate && selectedAP.isRecurrent) ||
                selectedAP.type.id == 1
            "
          >
            <el-form-item
              label="Fecha de evento"
              prop="endDate"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-input
                size="small"
                v-model="assignAP.eventDate"
                v-mask="'##/##/####'"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="selectedAP.options.title"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="assignAP.selectedOption"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                clearable
                filterable
              >
                <el-option
                  v-for="c in selectedAP.options.options"
                  :key="c"
                  :label="c"
                  :value="c"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="Comentarios">
              <el-input
                size="small"
                v-model="selectedAP.comment"
                placeholder=""
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="15"
          class="border-b mb-4 text-xs"
          v-if="selectedAP && selectedAP.category === 'range'"
        >
          <el-col :span="6" class="flex flex-col space-y-2">
            <el-form-item label="Recurrencia" prop="quincena">
              <el-row :gutter="15">
                <el-col :span="12">
                  <el-checkbox
                    size="small"
                    class="w-full"
                    v-model="assignAP.quincenaUno"
                    label="Quincena 1"
                    border
                  ></el-checkbox>
                </el-col>
                <el-col :span="12">
                  <el-checkbox
                    size="small"
                    class="w-full"
                    v-model="assignAP.quincenaDos"
                    label="Quincena 2"
                    border
                  ></el-checkbox>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="!selectedAP.isFixedValue">
            <el-form-item
              :label="
                `Cantidad: ${
                  selectedAP
                    ? selectedAP.affectsMethod == 1
                      ? '(DIAS)'
                      : '(DINERO)'
                    : ''
                }`
              "
              prop="noFixedValue"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-input-number
                :min="0"
                :step="0.01"
                placeholder="Cantidad"
                v-model="assignAP.noFixedValue"
                size="small"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col
            :span="3"
            v-if="
              (!selectedAP.endDate && selectedAP.isRecurrent) ||
                selectedAP.type.id == 1
            "
          >
            <el-form-item
              label="Fecha inicio"
              prop="endDate"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-input
                size="small"
                v-model="assignAP.startDate"
                v-mask="'##/##/####'"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
              />
            </el-form-item>
          </el-col>
          <el-col
            :span="3"
            v-if="
              (!selectedAP.endDate && selectedAP.isRecurrent) ||
                selectedAP.type.id == 1
            "
          >
            <el-form-item
              label="Fecha final"
              prop="endDate"
              :rules="{
                required: true,
                message: 'Este campo es requerido.',
                trigger: 'change',
              }"
            >
              <el-input
                size="small"
                v-model="assignAP.endDate"
                v-mask="'##/##/####'"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" class="flex flex-col space-y-2" v-if="selectedAP">
            <el-form-item label="Comentarios">
              <el-input
                size="small"
                v-model="selectedAP.comment"
                placeholder=""
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="border-b pb-4 mb-2">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="showAssignAP = false"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" native-type="submit"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="15">
        <el-col :span="24">
          <span class="uppercase font-semibold">
            Acciones de personal asignadas
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="apListActiveTab">
            <el-tab-pane name="completed">
              <span slot="label">
                Completadas
                <el-tag size="mini">
                  {{ completedAps.length }}
                </el-tag>
              </span>
              <el-row>
                <el-col :span="6">
                  <el-input
                    placeholder="Buscar"
                    v-model="searchCompletada"
                    size="small"
                    clearable
                    suffix-icon="el-icon-search"
                  />
                </el-col>
              </el-row>
              <el-table :data="completedAps" stripe size="mini">
                <el-table-column type="index" width="40" />
                <el-table-column
                  prop="personalAction.name"
                  label="Nombre"
                  min-width="350"
                />
                <el-table-column label="Forma" width="80">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.personalAction.affectsMethod == 1
                        ? "Dias"
                        : "Cantidad"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Valor" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.value | formatMoney }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Cantidad" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.amount }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Quincena 1" width="80" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.quincenaUno" />
                  </template>
                </el-table-column>
                <el-table-column label="Quincena 2" width="80" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.quincenaDos" />
                  </template>
                </el-table-column>
                <el-table-column
                  label="Fecha inicio"
                  prop="formatedStartDate"
                  width="90"
                />
                <el-table-column
                  label="Fecha fin"
                  prop="formatedEndDate"
                  width="90"
                />
                <el-table-column label="Estado" prop="status" width="80" />
              </el-table>
            </el-tab-pane>
            <el-tab-pane name="ongoing">
              <span slot="label">
                En curso
                <el-tag size="mini">{{ onGoingAps.length }}</el-tag>
              </span>
              <el-table :data="onGoingAps" stripe size="mini">
                <el-table-column type="index" width="40" />
                <el-table-column
                  prop="personalAction.name"
                  label="Nombre"
                  min-width="350"
                />
                <el-table-column label="Forma" width="80">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.personalAction.affectsMethod == 1
                        ? "Dias"
                        : "Cantidad"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Valor" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.value | formatMoney }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Cantidad" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.amount }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Quincena 1" width="80" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.quincenaUno" />
                  </template>
                </el-table-column>
                <el-table-column label="Quincena 2" width="80" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.quincenaDos" />
                  </template>
                </el-table-column>
                <el-table-column
                  label="Fecha inicio"
                  prop="formatedStartDate"
                  width="90"
                />
                <el-table-column
                  label="Fecha fin"
                  prop="formatedEndDate"
                  width="90"
                />
                <el-table-column label="Estado" prop="status" width="80" />
                <el-table-column
                  width="80"
                  align="center"
                  v-if="checkPermissions('Empleados:Todos', 'AP:delete')"
                >
                  <template slot-scope="scope">
                    <button
                      class="hover:bg-red-500 p-1 rounded-full hover:text-white"
                      @click="
                        deleteEmployeePersonalAction(
                          scope.row.id,
                          data.general.id
                        )
                      "
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button> </template
                ></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      :visible.sync="showPreviewDialog"
      width="900px"
      :close-on-click-modal="false"
      top="5%"
      :fullscreen="true"
    >
      <span slot="title">
        <el-row :gutter="15">
          <el-col :span="18">
            <span class="text-sm">{{
              `NOMBRE: ${data.general.name1} ${
                data.general.lastname1
              } | NUEVO CÓDIGO: ${data.general.code} | CODIGO ANTERIOR: ${
                data.general.priorCode !== null
                  ? data.general.priorCode
                  : "----"
              }`
            }}</span>
          </el-col>
          <el-col :span="5" class="flex justify-end">
            <el-button-group>
              <el-button
                size="mini"
                type="info"
                icon="el-icon-arrow-left"
                @click="prevEdit(data.general.id, rawEmployees, 'preview')"
              />
              <el-button
                size="mini"
                type="info"
                icon="el-icon-arrow-right"
                @click="nextEdit(data.general.id, rawEmployees, 'preview')"
              />
            </el-button-group>
          </el-col>
        </el-row>
      </span>
      <div>
        <el-row :gutter="15">
          <el-col :span="16">
            <template>
              <el-row :gutter="15" class="mb-2 border-b">
                <el-col :span="24">
                  <span class="uppercase font-semibold text-base text-gray-900"
                    >DATOS GENERALES</span
                  >
                </el-col>
              </el-row>
              <div class="mb-5 border-r">
                <el-row :gutter="15">
                  <el-col :span="7">
                    <img
                      id="output_image"
                      ref="output_image"
                      class="max-w-full max-h-full"
                      :src="previewImage"
                    />
                  </el-col>
                  <el-col :span="17">
                    <el-row :gutter="15" class="mb-4">
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">Primer nombre</p>
                        <span>{{ data.general.name1 }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">
                          Segundo nombre
                        </p>
                        <span>{{ data.general.name2 }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">Tercer nombre</p>
                        <span>{{ data.general.name3 }}</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="15" class="mb-4">
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">
                          Primer apellido
                        </p>
                        <span>{{ data.general.lastname1 }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">
                          Segundo apellido
                        </p>
                        <span>{{ data.general.lastname2 }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">
                          Apellido de casada
                        </p>
                        <span>{{ data.general.lastname3 }}</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="15" class="mb-4">
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">
                          Fecha de nacimiento
                        </p>
                        <span>{{ data.general.dob }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">Sexo</p>
                        <span>{{
                          data.general.sex == 1 ? "Hombre" : "Mujer"
                        }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">Estado civil</p>
                        <span>{{civilStatusName}}</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="15" class="mb-4">
                      <el-col :span="12">
                        <p class="font-semibold text-gray-800">Dirección 1</p>
                        <span>{{ data.general.address1 }}</span>
                      </el-col>
                      <el-col :span="12">
                        <p class="font-semibold text-gray-800">Dirección 2</p>
                        <span>{{ data.general.address2 }}</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="15">
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">País</p>
                        <span>{{ countryName(data.general.country) }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">Departamento</p>
                        <span>{{ stateName(data.general.state) }}</span>
                      </el-col>
                      <el-col :span="8">
                        <p class="font-semibold text-gray-800">Municipio</p>
                        <span>{{ cityName(data.general.city) }}</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-col>
          <el-col :span="8">
            <template>
              <el-row :gutter="15" class="mb-2 border-b">
                <el-col :span="24">
                  <span class="uppercase font-semibold text-base text-gray-800"
                    >INFORMACIÓN DE CONTACTO</span
                  >
                </el-col>
              </el-row>
              <div class="mb-5">
                <el-row :gutter="15" class="mb-4">
                  <el-col :span="12">
                    <p class="font-semibold text-gray-800">Celular</p>
                    <span
                      >{{ findCountryCode(data.general.cellphoneCode)
                      }}{{ data.general.cellphone }}</span
                    >
                  </el-col>
                  <el-col :span="12">
                    <p class="font-semibold text-gray-800">Teléfono</p>
                    <span>{{ data.general.phone }}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="15" class="mb-4">
                  <el-col :span="24">
                    <p class="font-semibold text-gray-800">Correo</p>
                    <span>{{ data.general.email }}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="15" class="mb-4">
                  <el-col :span="24">
                    <p class="font-semibold text-gray-800">
                      Nombre contacto de emergencia
                    </p>
                    <span>{{ data.general.emergencyPerson }}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :span="24">
                    <p class="font-semibold text-gray-800">
                      Número contacto de emergencia
                    </p>
                    <span>{{ data.general.emergencyPhone }}</span>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="7">
            <template>
              <el-row :gutter="15" class="mb-2 border-b">
                <el-col :span="24">
                  <span class="uppercase font-semibold text-base text-gray-800"
                    >DOCUMENTOS PERSONALES</span
                  >
                </el-col>
              </el-row>
              <div class="mb-5">
                <el-row
                  :gutter="15"
                  v-for="(item, index) in filteredDocuments(data.documents)"
                  :key="index"
                  class="mb-2"
                >
                  <el-col :span="12">
                    <p class="font-semibold text-gray-800">
                      Número de {{ documentName(item.documentType) }}
                    </p>
                    <span>{{ item.number }}</span>
                  </el-col>
                  <el-col :span="6">
                    <p class="font-semibold text-gray-800">Expedición</p>
                    <span>{{ item.expedition }}</span>
                  </el-col>
                  <el-col :span="6">
                    <p class="font-semibold text-gray-800">Expiración</p>
                    <span>{{ item.expiration }}</span>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-col>
          <el-col :span="11">
            <template>
              <el-row :gutter="15" class="mb-2 border-b">
                <el-col :span="24">
                  <span class="uppercase font-semibold text-base text-gray-800"
                    >INFORMACION DE FAMILIARES</span
                  >
                </el-col>
              </el-row>
              <div class="mb-5">
                <el-row :gutter="15" class="font-semibold text-gray-800">
                  <el-col :span="11">
                    <span>Nombre completo</span>
                  </el-col>
                  <el-col :span="4">
                    <span>Parentesco</span>
                  </el-col>
                  <el-col :span="4">
                    <span>Teléfono</span>
                  </el-col>
                  <el-col :span="5">
                    <span>Fecha de Nac.</span>
                  </el-col>
                </el-row>
                <el-row
                  :gutter="15"
                  v-for="(item, i) in data.employeeFamilies"
                  :key="i"
                  class="mb-1"
                >
                  <el-col :span="11">
                    <span>{{ item.name }}</span>
                  </el-col>
                  <el-col :span="4">
                    <span>{{ relationshipName(item.relationship) }}</span>
                  </el-col>
                  <el-col :span="4">
                    <span>{{ item.phone }}</span>
                  </el-col>
                  <el-col :span="5">
                    <span>{{ item.dob }}</span>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-col>
          <el-col :span="6">
            <template>
              <el-row :gutter="15" class="mb-2 border-b">
                <el-col :span="24">
                  <span class="uppercase font-semibold text-base text-gray-800"
                    >INFORMACION BANCARIA</span
                  >
                </el-col>
              </el-row>
              <div class="mb-5">
                <el-row :gutter="15" class="flex items-center justify-center">
                  <el-col :span="11" class="flex flex-col justify-center">
                    <p class="font-semibold text-gray-800">Banco</p>
                    <span>{{ bankName(bankAccountForm.bank) }}</span>
                  </el-col>
                  <el-col :span="13" class="flex flex-col justify-center">
                    <p class="font-semibold text-gray-800">N° de cuenta</p>
                    <span>{{ bankAccountForm.bankAccount }}</span>
                  </el-col>
                </el-row>
              </div>
            </template>
            <template>
              <el-row :gutter="15" class="mb-2">
                <el-col :span="24">
                  <span class="uppercase font-semibold text-base text-gray-800"
                    >OTRA INFORMACION</span
                  >
                </el-col>
              </el-row>
              <el-row
                :gutter="15"
                class="mb-2"
                v-if="checkPermissions('Empleados:Todos', 'Preview:viewSalary')"
              >
                <el-col :span="24">
                  <p class="font-semibold text-gray-800">Salario actual</p>
                  <span>{{ data.general.currentSalary | formatMoney }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="15" class="mb-2">
                <el-col :span="12">
                  <p class="font-semibold text-gray-800">Código anterior</p>
                  <span>{{ data.general.priorCode }}</span>
                </el-col>
                <el-col :span="12">
                  <p class="font-semibold text-gray-800">Incluir en planilla</p>
                  <span>{{
                    data.general.includeInPaysheet ? "SI" : "NO"
                  }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="15" class="mb-2">
                <el-col :span="24">
                  <p class="font-semibold text-gray-800">
                    Enfermedades que padece
                  </p>
                  <span>{{ data.general.diseasesList }}</span>
                </el-col>
              </el-row>
            </template>
          </el-col>
        </el-row>

        <template>
          <el-row :gutter="15" class="mb-2 border-b">
            <el-col :span="24">
              <span class="uppercase font-semibold text-base text-gray-800"
                >INFORMACION DE ESTUDIOS</span
              >
            </el-col>
          </el-row>
          <div class="mb-5">
            <el-row
              :gutter="15"
              v-for="(item, index) in data.studies"
              :key="index"
            >
              <el-col :span="3">
                <p class="font-semibold text-gray-800">Nivel</p>
                <span>{{ getStudyInfo(item.studyLevel, "level") }}</span>
              </el-col>
              <el-col :span="7">
                <p class="font-semibold text-gray-800">Institución</p>
                <el-tooltip
                  effect="dark"
                  :content="getStudyInfo(item.institution, 'institution')"
                  placement="top-start"
                >
                  <span class="truncate">{{
                    getStudyInfo(item.institution, "institution")
                  }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5">
                <div class="w-full">
                  <p class="font-semibold text-gray-800">Carrera</p>
                  <el-tooltip
                    effect="dark"
                    :content="getStudyInfo(item.career, 'carreer')"
                    placement="top-start"
                  >
                    <span>{{ getStudyInfo(item.career, "carreer") }}</span>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :span="5">
                <p class="font-semibold text-gray-800">Fechas</p>
                <span>{{ item.startDate }} - {{ item.endDate }}</span>
              </el-col>
              <el-col :span="3">
                <p class="font-semibold text-gray-800">Completo</p>
                <span>{{ item.completed ? "SI" : "NO" }}</span>
              </el-col>
            </el-row>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPreviewDialog = false" size="small"
          >Cancelar</el-button
        >
      </span>
    </el-dialog>

    <div class="flex flex-col space-y-4">
      <el-row :gutter="15" type="flex" justify="space-between">
        <el-col :span="5">
          <h3 class="text-l font-semibold">TODOS LOS EMPLEADOS</h3>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Buscar"
            v-model="searchEmployee"
            size="small"
            suffix-icon="el-icon-search"
          />
        </el-col>
      </el-row>
      <el-table
        :data="filteredEmployees"
        stripe
        size="mini"
        v-if="show"
        @selection-change="updateSelections"
        ref="employeesTable"
      >
        <el-table-column type="index" min-width="35" />
        <el-table-column label min-width="50">
          <template slot-scope="scope">
            <img :src="photo(scope.row)" class="w-8 h-8 rounded-full" />
          </template>
        </el-table-column>
        <el-table-column prop="code" label="Código" min-width="60" />
        <el-table-column label="Nombre" min-width="350">
          <template slot-scope="scope">
            <span>
              {{ scope.row.name1 }}
              {{ scope.row.name2 }}
              {{ scope.row.name3 }}
              {{ scope.row.lastname1 }}
              {{ scope.row.lastname2 }}
              {{ scope.row.lastname3 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Puesto" min-width="190">
          <template slot-scope="scope">
            <span>{{
              scope.row.department !== null ? scope.row.department.name : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Tipo de contrato" min-width="170">
          <template slot-scope="scope">
            <span>{{
              scope.row.contractType !== null ? scope.row.contractType.name : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Nómina" min-width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.paysheetType !== null ? scope.row.paysheetType.name : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Fecha de inicio" min-width="110">
          <template slot-scope="scope">
            <span>{{
              scope.row.contractStartDate | formatDate("YYYY-MM-DD")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Estado" min-width="70">
          <template slot-scope="scope">
            <span>{{ scope.row.status.name }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="80" align="center">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <el-button icon="el-icon-fa-ellipsis-v" size="small"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="openPreviewDialog(scope.row)">
                  <i class="el-icon-view"></i> Ver detalles
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:photo')"
                  @click.native="openEditDialog(scope.row, 'photo')"
                >
                  <i class="el-icon-picture-outline"></i> Editar fotografía
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:general')"
                  @click.native="openEditDialog(scope.row, 'general')"
                >
                  <i class="el-icon-edit-outline"></i> Editar generales
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:contact')"
                  @click.native="openEditDialog(scope.row, 'contact')"
                >
                  <i class="el-icon-phone-outline"></i> Editar contacto
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:documents')"
                  @click.native="openEditDialog(scope.row, 'documents')"
                  :class="{
                    'text-yellow-600': isPending('documents', scope.row),
                    'bg-yellow-200': isPending('documents', scope.row),
                    'font-semibold': isPending('documents', scope.row),
                  }"
                >
                  <i class="el-icon-document-checked"></i> Editar documentos
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:studies')"
                  @click.native="openEditDialog(scope.row, 'studies')"
                  :class="{
                    'text-yellow-600': isPending('studies', scope.row),
                    'bg-yellow-200': isPending('studies', scope.row),
                    'font-semibold': isPending('studies', scope.row),
                  }"
                >
                  <i class="el-icon-notebook-1"></i> Editar estudios
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:family')"
                  @click.native="openEditDialog(scope.row, 'family')"
                >
                  <i class="el-icon-user"></i> Editar familiares
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:bankInfo')"
                  @click.native="openEditDialog(scope.row, 'bank')"
                  :class="{
                    'text-yellow-600': isPending('bank', scope.row),
                    'bg-yellow-200': isPending('bank', scope.row),
                    'font-semibold': isPending('bank', scope.row),
                  }"
                >
                  <i class="el-icon-money"></i> Información bancaria
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermissions('Empleados:Todos', 'Edit:other')"
                  @click.native="openEditDialog(scope.row, 'other')"
                >
                  <i class="el-icon-s-operation"></i> Otros
                </el-dropdown-item>
                <el-dropdown-item
                  class="text-green-500 font-semibold"
                  @click.native="openShowAssignAP(scope.row)"
                >
                  <i class="el-icon-fa-bolt"></i> Asignar accion de p.
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-row :gutter="15" type="flex" justify="end">
        <el-pagination
          @size-change="handleSizeChange"
          :current-page.sync="page.number"
          :page-sizes="[5, 10, 15, 25, 50, 100]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="rawEmployees.length"
          :pager-count="5"
        />
      </el-row>
    </div>
  </div>
</template>

<script>
// const API_PATH =
//   process.env.NODE_ENV === "development"
//     ? "http://services.lws.local:4001"
//     : "http://services.lws.local:4001";

const API_PATH = "https://rrhh-api-gt.yes.com.sv"

import axios from "axios";
import * as R from "ramda";
import gql from "graphql-tag";
import { format, endOfMonth, startOfMonth, addDays } from "date-fns";

import NewTabGeneral from "./../../Contracts/Pages/NewTabGeneral";
import NewTabDocuments from "./../../Contracts/Pages/NewTabDocuments";
import DialogStudies from "./DialogStudies";
import DialogFamilies from "./DialogFamilies";
import DialogContact from "./DialogContact";
import DialogOther from "./DialogOther";
import { checkPermissions } from "../../../utils";

import photo from "./../../../assets/imgs/picture.jpg";

export default {
  name: "EmployeesAll",
  components: {
    NewTabGeneral,
    NewTabDocuments,
    DialogStudies,
    DialogFamilies,
    DialogContact,
    DialogOther,
  },
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          employees (where: { show: true } whereNot: { status: 1 }) {
            id
            code
            name1
            name2
            name3
            lastname1
            lastname2
            lastname3
            image
            contractStartDate
            department { name }
            contractType { name }
            paysheetType { name } 
            status { name }
            studies { id }
            bank { id }
            documents { documentType { id mask required } expedition expiration number }
            userActions { id }
            procuAguinaldo
          }
          countries { id name phoneCode phoneMask }
          banks( where: { active: true }) { id name }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.employees, data.banks, data.countries));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      searchEmployee: "",
      page: {
        size: 15,
        number: 1,
      },
      rawEmployees: [],
      rawBanks: [],
      show: true,
      hasSelections: false,
      employeesToEdit: [],
      showUpdateImage: false,
      civilStatusName:"",
      data: {
        general: {
          id: null,
          name1: null,
          name2: null,
          name3: null,
          lastname1: null,
          lastname2: null,
          lastname3: null,
          phone: null,
          cellphone: null,
          cellphoneCode: null,
          email: null,
          emergencyPhone: null,
          emergencyPerson: null,
          dob: null,
          address1: null,
          address2: null,
          country: null,
          state: null,
          city: null,
          sex: 1,
        },
        documents: [],
        laboral: {
          contractType: null,
          department: null,
          contractStartDate: null,
          contractEndDate: null,
          currentSalary: null,
        },
        studies: [],
        employeeFamilies: [],
      },
      levels: [],
      institutions: [],
      careers: [],
      relationships: [],
      documentTypes: [],
      countries: [],
      states: [],
      cities: [],
      previewImage: "",
      bankAccountForm: {
        bank: null,
        bankAccount: null,
      },
      bankAccountFormRules: {
        bank: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change",
          },
        ],
        bankAccount: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change",
          },
        ],
      },
      showEditDialog: false,
      tabRef: "general",
      loadingEdit: false,
      showPreviewDialog: false,
      loadingPreview: false,
      showAPs: false,
      showAssignAP: false,
      assignAP: {
        personalAction: "",
        noFixedValue: null,
        startDate:
          parseInt(format(new Date(), "DD")) >= 15
            ? format(
                new Date(new Date().getFullYear(), new Date().getMonth(), 16),
                "DD/MM/YYYY"
              )
            : format(startOfMonth(new Date()), "DD/MM/YYYY"),
        endDate: format(endOfMonth(new Date()), "DD/MM/YYYY"),
        eventDate: "",
        quincenaUno: false,
        quincenaDos: false,
        selectedMonth: "",
      },
      personalActions: [],
      personalActionsTypes: [
        {
          name: "Administrativas",
          id: "1",
        },
        {
          name: "Gratificaciones",
          id: "2",
        },
        {
          name: "Descuentos",
          id: "3",
        },
      ],
      selectedAP: null,
      rawPersonalActionsDetails: [],
      userActions: [],
      apListActiveTab: "ongoing",
      searchCompletada: "",
      paysheets: null,
    };
  },
  methods: {
    getFullData({ id, image }) {
      return new Promise((resolve, reject) => {
        axios
          .post("/", {
            query: `{
              employee (where: { id: "${id}" }) {
                id
                branchOffice { id }
                contractType { id }
                contractStartDate
                contractEndDate
                currentSalary
                code priorCode
                name1 name2 name3
                phone cellphone email
                phoneCode { id } cellphoneCode { id } emergencyPhoneCode { id }
                emergencyPhone
                emergencyPerson
                lastname1 lastname2 lastname3
                diseasesList priorCode
                dob
                address1 address2
                country { id } state { id } city { id }
                sex
                civilStatus { id name }
                documents { documentType { id mask required } expedition expiration number }
                userActions { id }
                procuAguinaldo
                includeInPaysheet
                currentSalary
                studies { 
                  id 
                  studyLevel { id }
                  institution { id }
                  career { id }
                  startDate 
                  endDate 
                  completed 
                } 
                department { id }
                jobPosition { id }
                oldDepartment { id }
                oldCostCenter { id }
                workingArea { id }
                bank { id } 
                bankAccount 
                employeeFamilies {
                  id
                  relationship { id }
                  name
                  phone
                  dob
                }
              }
              institutions { id name }
              careers { id name }
              studiesLevels { id name }
              relationships { id name }
              documentTypes { id shortName }
              banks( where: { active: true }) { id name }
              states { id name }
              cities { id name }
            }`,
          })
          .then((res) => {
            const { data, errors } = res.data;
            const doptions = {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            };

            this.data.general = {
              id: data.employee.id,
              name1: data.employee.name1,
              name2: data.employee.name2,
              name3: data.employee.name3,
              lastname1: data.employee.lastname1,
              lastname2: data.employee.lastname2,
              lastname3: data.employee.lastname3,
              phone: data.employee.phone,
              cellphone: data.employee.cellphone,
              email: data.employee.email,
              emergencyPhone: data.employee.emergencyPhone,
              emergencyPerson: data.employee.emergencyPerson,
              code: data.employee.code,
              priorCode: data.employee.priorCode,
              diseasesList: data.employee.diseasesList,
              includeInPaysheet: data.employee.includeInPaysheet,
              currentSalary: data.employee.currentSalary,
              userActions: data.employee.userActions
                ? data.employee.userActions.id
                : "",
              procuAguinaldo: data.employee.procuAguinaldo,
              dob: new Intl.DateTimeFormat("es-ES", doptions).format(
                new Date(data.employee.dob).setDate(
                  new Date(data.employee.dob).getDate() + 1
                )
              ),
              address1: data.employee.address1,
              address2: data.employee.address2,
              country: data.employee.country.id,
              phoneCode:
                data.employee.phoneCode != null
                  ? data.employee.phoneCode.id
                  : data.employee.country.id,
              cellphoneCode:
                data.employee.cellphoneCode != null
                  ? data.employee.cellphoneCode.id
                  : data.employee.country.id,
              emergencyPhoneCode:
                data.employee.emergencyPhoneCode != null
                  ? data.employee.emergencyPhoneCode.id
                  : data.employee.country.id,
              department: data.employee.department.id,
                branchOffice: data.employee.branchOffice ? data.employee.branchOffice.id : {},
              jobPosition: data.employee.jobPosition
                ? data.employee.jobPosition.id
                : "",
              oldCostCenter: data.employee.oldCostCenter
                ? data.employee.oldCostCenter.id
                : "",
              oldDepartment: data.employee.oldDepartment
                ? data.employee.oldDepartment.id
                : "",
              workingArea: data.employee.workingArea
                ? data.employee.workingArea.id
                : "",
              state: data.employee.state.id,
              city: data.employee.city.id,
              sex: data.employee.sex,
              civilStatus: R.isNil(data.employee.civilStatus)
                ? null
                : data.employee.civilStatus.id,
            };
            this.civilStatusName = R.isNil(data.employee.civilStatus)
              ? ""
              : data.employee.civilStatus.name;
            this.data.laboral = {
              contractType: data.employee.contractType.id,
              department: data.employee.department.id,
              contractStartDate: data.employee.contractStartDate,
              contractEndDate: data.employee.contractEndDate,
              currentSalary: data.employee.currentSalary,
            };
            this.data.documents = [];
            for (const document of data.employee.documents) {
              const { expedition, expiration, number } = document;
              const { id, mask } = document.documentType;
              this.data.documents.push({
                expedition:
                  expedition == null
                    ? null
                    : new Intl.DateTimeFormat("es-ES", doptions).format(
                        new Date(expedition).setDate(
                          new Date(expedition).getDate() + 1
                        )
                      ),
                expiration:
                  expiration == null
                    ? null
                    : new Intl.DateTimeFormat("es-ES", doptions).format(
                        new Date(expiration).setDate(
                          new Date(expiration).getDate() + 1
                        )
                      ),
                number: number == null ? "" : number,
                mask: mask,
                documentType: id,
              });
            }
            this.data.studies = [];
            for (const study of data.employee.studies) {
              const { startDate, endDate } = study;
              this.data.studies.push({
                studyLevel: study.studyLevel.id,
                institution: study.institution.id,
                career: study.career.id,
                startDate:
                  startDate === null
                    ? null
                    : new Intl.DateTimeFormat("es-ES", doptions).format(
                        new Date(startDate).setDate(
                          new Date(startDate).getDate() + 1
                        )
                      ),
                endDate:
                  endDate === null
                    ? null
                    : new Intl.DateTimeFormat("es-ES", doptions).format(
                        new Date(endDate).setDate(
                          new Date(endDate).getDate() + 1
                        )
                      ),
                completed: study.completed,
              });
            }
            this.data.employeeFamilies = [];
            for (const employeeFamily of data.employee.employeeFamilies) {
              const { dob } = employeeFamily;
              this.data.employeeFamilies.push({
                relationship: employeeFamily.relationship.id,
                name: employeeFamily.name,
                phone: employeeFamily.phone,
                dob:
                  dob === null
                    ? null
                    : new Intl.DateTimeFormat("es-ES", doptions).format(
                        new Date(dob).setDate(new Date(dob).getDate() + 1)
                      ),
              });
            }

            this.relationships = data.relationships;
            this.levels = data.studiesLevels;
            this.institutions = data.institutions;
            this.careers = data.careers;
            this.documentTypes = data.documentTypes;
            this.banks = data.rawBanks;
            this.states = data.states;
            this.cities = data.cities;
            this.userActions = data.users;

            this.bankAccountForm.bank = R.isNil(data.employee.bank)
              ? null
              : data.employee.bank.id;
            this.bankAccountForm.bankAccount = R.isNil(
              data.employee.bankAccount
            )
              ? null
              : data.employee.bankAccount;
            this.showBankAccountDialog = true;

            // Agrega la imagen
            this.data.general.id = id;
            if (!R.isNil(this.$refs.avatar)) {
              this.$refs.avatar.value = "";
            }
            this.previewImage = R.isNil(image) ? photo : `${API_PATH}/${image}`;
            resolve();
          })
          .catch(console.error);
      });
    },
    async openPreviewDialog(employee) {
      this.loadingPreview = true;
      await this.getFullData(employee);
      this.showPreviewDialog = true;
      this.loadingPreview = false;
    },
    async openEditDialog(employee, tab) {
      this.loadingEdit = true;
      await this.getFullData(employee);
      this.showEditDialog = true;
      this.tabRef = tab;
      this.loadingEdit = false;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    setData(employees, banks, countries) {
      const { id, dialog } = this.$route.query;
      if (dialog === "true") {
        this.openEditDialog({ id }, "general");
      }

      this.rawEmployees = checkPermissions("Empleados:Todos", "Page:view") // si es super muestra todos, si no, los filtra
        ? employees
        : employees.filter(
            (e) =>
              e.userActions && e.userActions.id == this.$store.getters.userID
          );
      this.rawBanks = banks;
      this.countries = countries;
    },
    photo(employee) {
      return R.isNil(employee.image) ? photo : `${API_PATH}/${employee.image}`;
    },
    reload() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    updateSelections() {
      this.hasSelections = this.$refs.employeesTable.selection.length > 0;
    },
    openEditFamiliesDialog({ id }) {
      axios
        .post("/", {
          query: `{
            employee(where: {id: "${id}"}) { 
              id
              
            }
            
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;

          this.showEditFamiliesDialog = true;
        });
    },
    submitBankAccount(formName, { bank, bankAccount }, id) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.$confirm(
          `¿Estás seguro que deseas actualizar la información bancaria de este empleado?`,
          "Confirmación",
          {
            confirmButtonText: `Si, cambiar`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      employeeUpdateBankAccount(
                        where: {id: "${id}"}
                        data: {
                          bank: "${bank}"
                          bankAccount: "${bankAccount}"
                        }
                      ){ id }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha actualizado la información bancaria correctamente.`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showBankAccountDialog = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, cambiar`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    afterUpdateEmployee(data) {
      axios
        .post("/", {
          query: `{
            employees ( where: { show: true } whereNot: { status: 1 }) {
              id
              code
              name1 name2 name3
              lastname1 lastname2 lastname3
              image
              contractStartDate
              department { name }
              contractType { name }
              paysheetType { name } 
              status { name }
              studies { id }
              bank { id }
              documents { documentType { id mask required } expedition expiration number }
              userActions { id }
            }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.rawEmployees = data.employees;
          }
        });
    },
    preview_image(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewImage = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    },
    uploadPicture() {
      if (R.isEmpty(this.$refs.avatar.value)) {
        this.$message.error("Debes seleccionar la nueva imagen primero");
        return false;
      }
      // return false;
      this.$confirm(
        `¿Estás seguro que deseas actualizar la foto para este empleado?`,
        "Confirmación",
        {
          confirmButtonText: `Si, actualizar`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              this.$apollo
                .mutate({
                  mutation: gql`
                    mutation($id: String!, $image: Upload!) {
                      employeeUploadPicture(where: { id: $id }, file: $image) {
                        id
                      }
                    }
                  `,
                  variables: {
                    id: this.data.general.id,
                    image: this.$refs.avatar.files[0],
                  },
                })
                .then((res) => {
                  const { data, errors } = res;
                  if (R.isNil(errors)) {
                    axios
                      .post("/", {
                        query: `{
                          employees ( where: { show: true } whereNot: { status: 1 }) {
                            id
                            code
                            name1 name2 name3
                            lastname1 lastname2 lastname3
                            image
                            contractStartDate
                            department { name }
                            contractType { name }
                            paysheetType { name } 
                            status { name }
                            studies { id }
                            bank { id }
                            documents { documentType { id mask required } expedition expiration number }
                            userActions { id }
                          }
                        }`,
                      })
                      .then((res) => {
                        const { data, errors } = res.data;
                        if (R.isNil(errors)) {
                          this.rawEmployees = data.employees;
                        }
                      });
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? `Se han actualizado la foto correctamente.`
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  this.showUpdateImage = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = `Si, actualizar`;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    isPending(type, employee) {
      let isPending = false;
      switch (type) {
        case "studies":
          isPending = R.isEmpty(employee.studies);
          break;
        case "bank":
          isPending = R.isNil(employee.bank);
          break;
        case "documents":
          isPending = R.isNil(employee.bank);
          break;
      }
      return isPending;
    },
    nextEdit(id, employees, type) {
      const length = employees.length;
      const current = employees.find((e) => e.id === id);
      const index = employees.indexOf(current);
      const next = index + 1 < length ? index + 1 : 0;
      switch (type) {
        case "preview":
          this.openPreviewDialog(employees[next]);
          break;
        case "edit":
          this.openEditDialog(employees[next], this.tabRef);
          break;
      }
    },
    prevEdit(id, employees, type) {
      const length = employees.length;
      const current = employees.find((e) => e.id === id);
      const index = employees.indexOf(current);
      const previous = index - 1 >= 0 ? index - 1 : length - 1;
      switch (type) {
        case "preview":
          this.openPreviewDialog(employees[previous]);
          break;
        case "edit":
          this.openEditDialog(employees[previous], this.tabRef);
          break;
      }
    },
    relationshipName(id) {
      return R.isEmpty(this.relationships)
        ? ""
        : this.relationships.find((r) => r.id === id).name;
    },
    documentName(id) {
      return R.isEmpty(this.documentTypes)
        ? ""
        : this.documentTypes.find((dt) => dt.id === id).shortName;
    },
    countryName(id) {
      return R.isEmpty(this.countries) || R.isNil(id)
        ? ""
        : this.countries.find((c) => c.id === id).name;
    },
    stateName(id) {
      return R.isEmpty(this.states) || R.isNil(id)
        ? ""
        : this.states.find((s) => s.id === id).name;
    },
    cityName(id) {
      return R.isEmpty(this.cities) || R.isNil(id)
        ? ""
        : this.cities.find((c) => c.id === id).name;
    },
    bankName(id) {
      return R.isEmpty(this.rawBanks) || R.isNil(id)
        ? ""
        : this.rawBanks.find((b) => b.id === id).name;
    },
    filteredDocuments(documents) {
      return documents.filter(
        (d) => !R.isEmpty(d.number) && !R.isNil(d.number) && d.number !== "null"
      );
    },
    getStudyInfo(id, type) {
      switch (type) {
        case "level":
          return this.levels.find((l) => l.id === id).name;
          break;
        case "institution":
          return this.institutions.find((l) => l.id === id).name;
          break;
        case "carreer":
          return this.careers.find((l) => l.id === id).name;
          break;
      }
    },
    findCountryCode(code) {
      if (code != null) {
        return this.countries.find((c) => c.id == code).phoneCode;
      }
      return "";
    },
    async openShowAssignAP(employee) {
      this.loadingEdit = true;
      await this.getFullData(employee);
      axios
        .post("/", {
          query: `
          {
            employeePersonalActions(where:{ employee: "${employee.id}" }) {
              id
              personalAction { name affectsMethod isFixedValue isRecurrent discount type }
              startDate
              endDate
              value
              amount
              affectsPaysheet
              isRecurrent
              quincenaUno
              quincenaDos
              employee { paysheetType { id } }
            }
            personalActions {
              id
              type
              name
              affectsPaysheet
              affectsMethod
              isFixedValue
              fixedValue
              isRecurrent
              updateStatus
              active
              deductISR
              baseSalary
              assignable
              assignedBySupervisor
              category
              options
            }
            paysheets { 
              id 
              startDate 
              endDate 
              paysheetType { id }  
            } 
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.rawPersonalActionsDetails = data.employeePersonalActions;
            this.paysheets = data.paysheets;

            const personalActions = checkPermissions(
              "Empleados:Todos",
              "Page:view"
            ) // si es super los muestra todos, sino, los filtra
              ? data.personalActions
              : data.personalActions.filter((pa) => pa.assignedBySupervisor);
            this.personalActions = personalActions
              .filter((d) => {
                return d.assignable && d.active;
              })
              .map((d) => {
                return {
                  ...d,
                  type: this.personalActionsTypes.find((p) => p.id == d.type),
                };
              });
            this.showAssignAP = true;
            this.loadingEdit = false;
          }
        });
    },
    getSelectedAP(id) {
      this.selectedAP = this.personalActions.find((pa) => pa.id == id);
    },
    submitNewAP(formName, assignAP, selectedAP, employee) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          `¿Estás seguro que deseas agregar esta accion de personal?`,
          "Confirmación",
          {
            confirmButtonText: `Si, agregar`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";

                // Debe enviarse en canitdad ($)
                let value = null;
                switch (selectedAP.affectsMethod) {
                  case 1: //Dias
                    // convierte dias a cantidad
                    value =
                      (employee.laboral.currentSalary / 30) *
                      assignAP.noFixedValue;
                    break;

                  case 2: // Cantidad
                    value = selectedAP.isFixedValue
                      ? selectedAP.fixedValue
                      : assignAP.noFixedValue;
                    break;
                }
                // Multiplica por 1 en caso de gratificaciones y por -1 en caso de descuentos
                switch (selectedAP.type.id) {
                  case "1":
                    value = value * 1;
                    break;
                  case "2":
                    value = value * 1;
                    break;
                  case "3":
                    value = value * -1;
                    break;
                }
                let quincenaUno = assignAP.quincenaUno;
                let quincenaDos = assignAP.quincenaDos;
                let startDate = assignAP.startDate
                  .split("/")
                  .reverse()
                  .join("-");
                let endDate = assignAP.endDate
                  .split("/")
                  .reverse()
                  .join("-");
                let eventDate = null;
                let selectedOption = null;

                if (selectedAP.category === "single") {
                  quincenaUno = false;
                  quincenaDos = false;
                  eventDate = `"${assignAP.eventDate
                    .split("/")
                    .reverse()
                    .join("-")}"`;
                  selectedOption = `"${assignAP.selectedOption}"`;
                  switch (assignAP.quincena) {
                    case "Q1":
                      startDate = format(
                        startOfMonth(assignAP.selectedMonth),
                        "YYYY-MM-DD"
                      );
                      endDate = format(
                        addDays(startOfMonth(assignAP.selectedMonth), 14),
                        "YYYY-MM-DD"
                      );
                      quincenaUno = true;
                      break;
                    case "Q2":
                      startDate = format(
                        addDays(startOfMonth(assignAP.selectedMonth), 15),
                        "YYYY-MM-DD"
                      );
                      endDate = format(
                        endOfMonth(assignAP.selectedMonth),
                        "YYYY-MM-DD"
                      );
                      quincenaDos = true;
                      break;
                  }
                }

                axios
                  .post("/", {
                    query: `mutation { 
                      employeePersonalActionCreate(data: {
                        employee: "${employee.general.id}"
                        personalAction: "${selectedAP.id}"
                        value: ${value.roundDecimal()}
                        affectsPaysheet: ${selectedAP.affectsPaysheet}
                        isRecurrent: ${selectedAP.isRecurrent}
                        quincenaUno: ${quincenaUno}
                        quincenaDos: ${quincenaDos}
                        comment: "${selectedAP.comment}"
                        startDate: "${startDate}"
                        endDate: "${endDate}"
                        amount: ${assignAP.noFixedValue}
                        eventDate: ${eventDate}
                        selectedOption: ${selectedOption}
                      })
                      { 
                        id
                        personalAction { name affectsMethod isFixedValue isRecurrent}
                        startDate
                        endDate
                        value
                        affectsPaysheet
                        isRecurrent
                        quincenaUno
                        quincenaDos
                        employee { paysheetType { id } }
                      }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha asignado la accion de personal correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.rawPersonalActionsDetails =
                      data.employeePersonalActionCreate;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, agregar`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    deleteEmployeePersonalAction(id, employee) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar esta accion de personal?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { 
                    employeePersonalActionDelete(where: {id: ${id} employee: "${employee}"}) { 
                        id
                        personalAction { name affectsMethod isFixedValue isRecurrent}
                        startDate
                        endDate
                        value
                        affectsPaysheet
                        isRecurrent
                        quincenaUno
                        quincenaDos
                        employee { paysheetType { id } }
                     } 
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado la accion de personal correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                  });
                  this.rawPersonalActionsDetails =
                    data.employeePersonalActionDelete;
                  done();
                })
                .catch(console.error)
                .then((alw) => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                });
            } else {
              done();
            }
          },
        }
      );
    },
    checkPermissions(path, action = null) {
      return checkPermissions(path, action);
    },
  },
  computed: {
    filteredEmployees() {
      return this.rawEmployees
        .filter((employee) => {
          const search = this.searchEmployee.toLowerCase();
          const {
            code,
            name1,
            name2,
            name3,
            lastname1,
            lastname2,
            lastname3,
            department,
            contractType,
            status,
            documents,
          } = employee;
          let fullName = "";
          fullName += !name1 ? "" : `${name1.trim()} `;
          fullName += !name2 ? "" : `${name2.trim()} `;
          fullName += !name3 ? "" : `${name3.trim()} `;
          fullName += !lastname1 ? "" : `${lastname1.trim()} `;
          fullName += !lastname2 ? "" : `${lastname2.trim()} `;
          fullName += !lastname3 ? "" : `${lastname3.trim()} `;

          return (
            code.toLowerCase().includes(search) ||
            fullName.toLowerCase().includes(search) ||
            department.name.toLowerCase().includes(search) ||
            contractType.name.toLowerCase().includes(search) ||
            status.name.toLowerCase().includes(search) ||
            documents.find(
              (d) => d.number != null && d.number.toLowerCase().includes(search)
            )
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
    personalActionsDetails() {
      return this.rawPersonalActionsDetails
        .map((pa) => {
          const [syear, smonth, sday] = pa.startDate.split("-");
          const startDate = new Date(`${smonth}/${sday}/${syear}`);

          let endDate = null;
          if (pa.endDate) {
            const [eyear, emonth, eday] = pa.endDate.split("-");
            endDate = new Date(`${emonth}/${eday}/${eyear}`);
          }

          const paysheet = this.paysheets
            .filter((p) => p.paysheetType.id === pa.employee.paysheetType.id)
            .sort((a, b) => {
              if (parseInt(a.id) < parseInt(b.id)) return 1;
              if (parseInt(a.id) > parseInt(b.id)) return -1;
              return 0;
            })[0];

          const [psyear, psmonth, psday] = paysheet.startDate.split("-");
          const [peyear, pemonth, peday] = paysheet.endDate.split("-");

          const paysheetStartDate = new Date(`${psmonth}/${psday}/${psyear}`);
          const paysheetEndDate = new Date(`${pemonth}/${peday}/${peyear}`);

          let completed = false;
          let status = "En curso ";

          // Si startDateAP menor que startDatePaysheet
          if (startDate > paysheetEndDate) {
            status = "Pendiente ";
          }
          // Si endDateAP menor paysheetStartDate
          else if (endDate < paysheetStartDate) {
            status = "Completado ";
            completed = true;
          }

          let value =
            pa.value *
            (pa.personalAction.type == 1 && pa.personalAction.discount
              ? -1
              : 1);
          return {
            ...pa,
            status,
            completed,
            startDate,
            endDate,
            value,
            formatedEndDate: endDate ? format(endDate, "DD/MM/YYYY") : "",
            formatedStartDate: format(startDate, "DD/MM/YYYY"),
          };
        })
        .sort((a, b) => {
          if (a.endDate > b.endDate) return 1;
          if (a.endDate < b.endDate) return -1;
          return 0;
        });
    },
    onGoingAps() {
      return this.personalActionsDetails.filter((pa) => !pa.completed);
    },
    completedAps() {
      const search = this.searchCompletada.toLowerCase();
      return this.personalActionsDetails.filter((pa) => {
        let searchPass = true;
        if (search) {
          searchPass = pa.personalAction.name
            .trim()
            .toLowerCase()
            .includes(search);
        }
        return pa.completed && searchPass;
      });
    },
  },
};
</script>
